import {
    Component,
    OnInit,
    ViewChild,
    ElementRef,
    Input
} from "@angular/core";
import ReactDOM from "react-dom";
import React from "react";
import styled from "@emotion/styled";
import { SelectField } from "@dfds-ui/react-components";
import { SelectItem } from './select.model';
import { FormControl } from '@angular/forms';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

const SelectFieldStyled = styled(SelectField)`
    select {
        background: none;
        padding-left: 15p;
        padding-right: 50px;
        padding-top: 0px;
        padding-bottom: 0px;
        border-radius: 0;
    }

    svg {
        color: rgb(107, 178, 226);
    }
`

@Component({
    selector: "sbw-select-field",
    template: "<div #react></div>"
})
export class SelectFieldComponent implements OnInit {
    hasInit = false
    @ViewChild("react", { static: true }) react: ElementRef;

    @Input() name: string;
    @Input() label: string;
    @Input() control: FormControl;
    @Input() items: SelectItem[];
    @Input() errorMessage: string;

    renderSubject = new Subject()

    ngOnInit() {
        this.hasInit = true
        this.renderSubject.pipe(debounceTime(10)).subscribe(() => this.renderReal())
        this.control.valueChanges.subscribe(() => this.render())
        this.render()
    }

    private render() {
        this.renderSubject.next()
    }

    renderReal() {
        // If label contains _ we set the &nbsp; for non breaking space
        const getLabel = () => this.label == "_" ? <span>&nbsp;</span> : this.label
        const onChange = (data) => { this.control.setValue(data.target.value) }

        // Added shared className to remove styles that should not overwrite the shared component styles
        ReactDOM.render(
            <SelectFieldStyled className="shared" name={this.name} label={getLabel()} selected={this.control ? this.control.value : null} onChange={onChange} errorMessage={this.errorMessage}>
                {this.items.map(i => <option key={i.value} value={i.value}>{i.text}</option>)}
            </SelectFieldStyled>,
            this.react.nativeElement
        );
    }

    ngOnChanges(s) {
        if (s.label) this.render()
    }
}
